module.exports = __webpack_public_path__ + "img/0cc28b7.png";